import React, { useEffect, useState } from 'react'
import { cardsInfo, getAll } from '../../data/data'
import { RecruiterCards } from '../RecruiterCards/RecruiterCards'
import { Link } from 'react-router-dom';
import { MutatingDots } from 'react-loader-spinner';
import './RecruiterContainer.css'

export const RecruiterContainer = () => {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    useEffect(() => {
            getAll(cardsInfo)
            .then(el => setItems(el))
            .finally(() => setLoading(false))
        
    }, [])
        return loading ? 
            <div className='flex justify-center items-center spinner'>
                <MutatingDots 
                height="100"
                width="100"
                color="#570DF8"
                secondaryColor= '#2F2E41'
                radius='12.5'
                ariaLabel="mutating-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                />
            </div> 
            :
            <section>
                <h2 className='text-center	text-5xl mb-5 text-white sm:text-3xl pt-2'>¿Qué te gustaría ver?</h2>
                <RecruiterCards items={items}/>
                <div className="flex justify-center align-center pb-5">
                    <Link to='/' className="btn btn-primary flex justify-self-center self-center w-1/5 ">Volver</Link>
                </div>
            </section>
    
}
